// ============================================================
// Contenido del sitio institucional de Access Informática.
// Centralizado para editar textos y datos sin tocar los componentes.
// ============================================================

export const company = {
  name: "Access Informática",
  tagline: "Software integral de Medicina Laboral y Accidentología",
  hero: "Expertos en software para Prestadores de Medicina Laboral, Servicios Médicos de Empresas y ART.",
  founded: 1996,
  yearsExperience: 30,
  phone: "(54 11) 7079-9779",
  phoneHref: "+541170799779",
  email: "info@accessinformatica.com.ar",
};

export const nav = [
  { label: "Inicio", href: "#inicio" },
  { label: "Qué hacemos", href: "#que-hacemos" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Talento", href: "#talento" },
  { label: "Clientes", href: "#clientes" },
  { label: "Contacto", href: "#contacto" },
];

export const stats = [
  { value: 30, suffix: "+", label: "Años de experiencia" },
  { value: 50, suffix: "+", label: "Clientes activos" },
  { value: 3, suffix: "", label: "Verticales de salud laboral" },
  { value: 100, suffix: "%", label: "Foco en calidad certificada" },
];

export const services = [
  {
    id: "prestadores",
    icon: "stethoscope",
    title: "Prestadores de Medicina Laboral",
    summary:
      "Digitalizá la operación completa del prestador con conectividad directa a las ART y autogestión para tus clientes.",
    features: [
      "Historia clínica electrónica",
      "Documentación digitalizada",
      "Conectividad con ART",
      "Portal y autogestión para clientes",
      "Receta electrónica y teleconsulta",
      "Integración con equipos de diagnóstico",
    ],
  },
  {
    id: "empresas",
    icon: "building",
    title: "Servicios Médicos de Empresas",
    summary:
      "Una historia clínica integral que reduce costos operativos y pone la información al alcance de tu equipo médico.",
    features: [
      "Historia clínica integral",
      "Reducción de costos operativos",
      "Acceso simple a la información",
      "Protocolos de tratamiento",
      "Receta electrónica",
      "Teleconsulta",
    ],
  },
  {
    id: "art",
    icon: "shield",
    title: "Aseguradoras de Riesgo del Trabajo (ART)",
    summary:
      "Gestioná afiliaciones, prevención y siniestros con integración nativa a los organismos de control.",
    features: [
      "Afiliaciones y prevención",
      "Gestión de siniestros",
      "Integración con SRT y SSN",
      "App para trabajadores",
      "Portales especializados",
    ],
  },
];

export const professionalServices = [
  "Implementación y puesta en marcha",
  "Asistencia, soporte y mantenimiento técnico-funcional",
  "Cumplimiento de SLA según criticidad",
  "Consultoría especializada",
];

export const values = [
  {
    icon: "zap",
    title: "Energía positiva",
    text: "Construimos entornos felices, cercanos y flexibles donde da gusto trabajar.",
  },
  {
    icon: "heart",
    title: "Los valores no se negocian",
    text: "Responsabilidad, transparencia y diversidad son nuestra base innegociable.",
  },
  {
    icon: "award",
    title: "Nos desvela la calidad",
    text: "Procesos certificados bajo la norma ISO 9001:2015 en todo lo que hacemos.",
  },
  {
    icon: "sparkles",
    title: "Aplausos para la creatividad",
    text: "Innovación constante para anticiparnos a las necesidades del mercado.",
  },
  {
    icon: "door",
    title: "Puertas abiertas",
    text: "Canales de comunicación siempre disponibles, en todas las direcciones.",
  },
];


export const talent = {
  intro:
    "Somos personas creando tecnología para personas. Por eso cuidamos cada Access-O a una mejor experiencia de trabajo.",
  badge: "Great Place to Work® Argentina",
  items: [
    {
      icon: "balance",
      title: "Access-O al Equilibrio",
      text: "Una vida laboral balanceada, con flexibilidad real.",
    },
    {
      icon: "party",
      title: "Access-O a la Celebración",
      text: "Reuniones y momentos para conectar como equipo.",
    },
    {
      icon: "growth",
      title: "Access-O al Talento",
      text: "Desarrollo de capacidades y oportunidades de crecimiento.",
    },
    {
      icon: "globe",
      title: "Access-O a Experiencias únicas",
      text: "Cercanía e inclusión en cada instancia.",
    },
  ],
};

// Logos reales de clientes en /public/clients (client-01.png ... client-51.png).
export const clients = Array.from({ length: 51 }, (_, i) => ({
  src: `/clients/client-${String(i + 1).padStart(2, "0")}.png`,
  alt: `Cliente de Access Informática ${i + 1}`,
}));

export const contact = {
  phone: company.phone,
  phoneHref: company.phoneHref,
  email: company.email,
  socials: [
    {
      name: "Instagram",
      handle: "@access_informatica_",
      href: "https://instagram.com/access_informatica_",
      icon: "instagram",
    },
    {
      name: "LinkedIn",
      handle: "/company/access-informatica",
      href: "https://www.linkedin.com/company/access-informatica/",
      icon: "linkedin",
    },
    {
      name: "Facebook",
      handle: "AccessInformaticaSoftware",
      href: "https://www.facebook.com/AccessInformaticaSoftware",
      icon: "facebook",
    },
  ],
};

export const externalLinks = {
  clientAccess:
    "https://accessinformatica.atlassian.net/servicedesk/customer/portals",
  mlPoint: "https://mlpoint.com.ar",
  blog: "#",
};
